"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const libsodium_wrappers_1 = __importDefault(require("libsodium-wrappers"));
const Mnemonic_1 = __importDefault(require("./Mnemonic"));
const Address_1 = __importDefault(require("./Address"));
const KeyType_1 = require("./KeyType");
const NetType_1 = require("./NetType");
// extend SodiumKeyPair?
class Keypair {
    constructor(keypair, netType) {
        this.keypair = keypair;
        this.publicKey = keypair.publicKey;
        this.privateKey = keypair.privateKey;
        this.keyType = keypair.keyType;
        this.netType = netType || NetType_1.MAINNET;
    }
    get address() {
        return new Address_1.default(0, this.netType, KeyType_1.ED25519_KEY_TYPE, this.publicKey);
    }
    static async makeRandom(netType) {
        await libsodium_wrappers_1.default.ready;
        const keypair = libsodium_wrappers_1.default.crypto_sign_keypair();
        return new Keypair(keypair, netType);
    }
    static async fromWords(words, netType) {
        const mnenomic = new Mnemonic_1.default(words);
        const keypair = await this.fromMnemonic(mnenomic, netType);
        return keypair;
    }
    static async fromMnemonic(mnenomic, netType) {
        await libsodium_wrappers_1.default.ready;
        const entropy = mnenomic.toEntropy();
        const seed = entropy.length === 16 ? Buffer.concat([entropy, entropy]) : entropy;
        return Keypair.fromEntropy(seed, netType);
    }
    static async fromEntropy(entropy, netType) {
        await libsodium_wrappers_1.default.ready;
        const entropyBuffer = Buffer.from(entropy);
        if (Buffer.byteLength(entropyBuffer) !== 32)
            throw new Error('Invalid entropy, must be 32 bytes');
        const keypair = libsodium_wrappers_1.default.crypto_sign_seed_keypair(entropy);
        return new Keypair(keypair, netType);
    }
    async sign(message) {
        await libsodium_wrappers_1.default.ready;
        const signature = libsodium_wrappers_1.default.crypto_sign_detached(message, this.privateKey);
        return signature;
    }
}
exports.default = Keypair;
//# sourceMappingURL=Keypair.js.map